import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=479faab0"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js"
import style0 from "./PreloaderComponent.vue?vue&type=style&index=0&id=479faab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports